// Shared components
import { ConfirmationDialog } from '../common/ConfirmationDialog';

// Hooks
import { useTranslation } from '@hooks/useTranslation';

interface DeletePriceModifierDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

// Confirmation step for deleting a price modifier (discount or surcharge). The
// message notes that modifiers already applied to events are unaffected — the
// server soft-deletes (discards) the modifier and applied rows keep their
// link. Mirrors DeleteLocationDialog.
export function DeletePriceModifierDialog({
  open,
  onOpenChange,
  onConfirm,
  isDeleting = false,
}: DeletePriceModifierDialogProps) {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={t('delete_dialog.title')}
      message={t('delete_dialog.message')}
      confirmLabel={t('delete_dialog.confirm')}
      cancelLabel={t('delete_dialog.cancel')}
      confirmingLabel={t('delete_dialog.loading')}
      isPending={isDeleting}
    />
  );
}
